import React from "react";
import Marquee from "react-fast-marquee";
import { Building2 } from "lucide-react";
import { useSiteContent } from "../../context/SiteContent";

export const ClientMarquee = () => {
  const { content } = useSiteContent();
  const list = (content?.clientLogos || []).filter((c) => c.isActive);
  if (!list.length) return null;

  return (
    <section className="py-16 md:py-20 bg-white border-y border-helios-line" data-testid="client-marquee">
      <div className="max-w-7xl mx-auto px-4 md:px-8 mb-10">
        <p className="text-center font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
          Trusted by Leading Solar EPCs, Project Developers &amp; Industrial Asset Owners
        </p>
      </div>
      <Marquee speed={40} gradient gradientColor="#ffffff" gradientWidth={100} pauseOnHover>
        {list.concat(list).map((c, i) => {
          const chip = (
            <div className="group mx-5 flex items-center gap-3 rounded-xl border border-helios-line bg-helios-mist px-6 py-4 transition-colors hover:border-helios-cyan/50"
              data-testid={`client-logo-${c.id}`}>
              {c.logoUrl ? (
                <img src={c.logoUrl} alt={c.clientName}
                  className="h-8 w-auto object-contain grayscale opacity-60 transition-all group-hover:grayscale-0 group-hover:opacity-100" />
              ) : (
                <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-white text-slate-300 transition-colors group-hover:text-helios-cyan">
                  <Building2 size={18} />
                </span>
              )}
              <p className="font-display font-bold text-helios-slate/60 transition-colors group-hover:text-helios-slate leading-tight whitespace-nowrap">{c.clientName}</p>
            </div>
          );
          return c.websiteUrl ? (
            <a key={`${c.id}-${i}`} href={c.websiteUrl} target="_blank" rel="noopener noreferrer">{chip}</a>
          ) : (
            <div key={`${c.id}-${i}`}>{chip}</div>
          );
        })}
      </Marquee>
    </section>
  );
};
